import type { PermissionKey } from '@erp/shared';
import {
  BarChart3,
  Building2,
  CalendarCheck,
  FileText,
  FileUp,
  Handshake,
  Inbox,
  Home,
  KeyRound,
  ListChecks,
  Plug,
  LockKeyhole,
  Network,
  ShieldCheck,
  Store,
  UserCog,
  Users,
  Wallet,
  Webhook,
  Workflow,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Hidden without this permission (the API still enforces it). */
  permission?: PermissionKey;
  /** Future module: shown disabled with "Próximamente". */
  comingSoon?: boolean;
}

export interface NavSection {
  title: string | null;
  items: NavItem[];
}

export const NAV: NavSection[] = [
  {
    title: null,
    items: [
      { label: 'Inicio', to: '/', icon: Home },
      { label: 'Contactos', to: '/contactos', icon: Users, permission: 'records.view' },
      {
        label: 'Propiedades',
        to: '/propiedades',
        icon: Building2,
        permission: 'records.view',
      },
      { label: 'Negocios', to: '/negocios', icon: Handshake, permission: 'records.view' },
      { label: 'Agenda', to: '/agenda', icon: CalendarCheck, permission: 'records.view' },
      { label: 'Cierres y comisiones', to: '/cierres', icon: Wallet, comingSoon: true },
      { label: 'Documentos', to: '/documentos', icon: FileText, comingSoon: true },
      { label: 'Red inmobiliaria', to: '/red', icon: Network, comingSoon: true },
      { label: 'Reportes', to: '/reportes', icon: BarChart3, comingSoon: true },
    ],
  },
  {
    title: 'Administración',
    items: [
      { label: 'Usuarios', to: '/admin/usuarios', icon: UserCog, permission: 'users.manage' },
      { label: 'Roles y permisos', to: '/admin/roles', icon: KeyRound, permission: 'roles.manage' },
      {
        label: 'Inmobiliaria',
        to: '/admin/inmobiliaria',
        icon: Store,
        permission: 'settings.manage',
      },
      {
        label: 'Embudos',
        to: '/admin/embudos',
        icon: Workflow,
        permission: 'settings.manage',
      },
      {
        label: 'Leads',
        to: '/admin/leads',
        icon: Inbox,
        permission: 'settings.manage',
      },
      {
        label: 'Importar datos',
        to: '/importaciones',
        icon: FileUp,
        permission: 'data.import',
      },
      {
        label: 'Tipos de actividad',
        to: '/admin/actividades',
        icon: ListChecks,
        permission: 'settings.manage',
      },
      {
        label: 'Claves de API',
        to: '/admin/claves-api',
        icon: Plug,
        permission: 'api_keys.manage',
      },
      {
        label: 'Webhooks',
        to: '/admin/webhooks',
        icon: Webhook,
        permission: 'api_keys.manage',
      },
      {
        label: 'Seguridad',
        to: '/admin/seguridad',
        icon: ShieldCheck,
        permission: 'settings.manage',
      },
      {
        label: 'Privacidad',
        to: '/admin/privacidad',
        icon: LockKeyhole,
        permission: 'privacy.manage',
      },
    ],
  },
];
